<template>
  <div class="home">
    <common-header></common-header>
    <img src="../img/m/progress.png" alt="" class="progress">
    <div class="page_content">
      <div class="content_nav">
        <div :class="['nav_item', resource == 1 ? 'active_item' : '']" @click="changeResource(1)">
          <span class="cn_name">短视频</span>
          <span class="en_name">VLOG</span>
        </div>
        <div :class="['nav_item', resource == 2 ? 'active_item' : '']" @click="changeResource(2)">
          <span class="cn_name">图片故事</span>
          <span class="en_name">PLOG</span>
        </div>
      </div>
      <ul class="works_list">
        <li @click="addWork()">
          <img src="../img/m/add.png" alt="" class="addIcon">
          <div style="height: 1.57rem"></div>
        </li>
        <li v-for="(v, i) in dataList" :key="i">
          <div class="cover_con">
            <img :src="'https://collection2021-cos.chineseplus.net/'+v[resource == 1 ? 'video_cover' : 'cover']" alt="" class="cover_img">
            <img src="../img/m/video_btn.png" alt="" class="video_btn" v-if="resource == 1">
            <div class="three_con" @click="showSettingsFun(v)" v-if="[0,2].includes(v.status)">
              <img src="../img/m/threeDot.png" alt="">
            </div>
            <img src="../img/m/finish_flag.png" alt="" class="finish_flag" v-show="v.status == 1">
            <img src="../img/m/fing_flag.png" alt="" class="finish_flag" v-show="v.status == 3">
            <div class="join_error" v-show="v.status == 2">
              本作品参赛审核未通过，{{v.check_desc}}，请修正重新参赛，谢谢！
            </div>
          </div>
          <div class="work_name">{{v.title}}</div>
          <div class="author">提供者：{{v.user_name}}</div>
          <div class="country">所在国：{{v.cn}}</div>
        </li>
      </ul>
    </div>
    <van-popup v-model="showSetting" position="bottom">
      <ul class="seting_con">
        <li @click="manageFun()" v-if="resource == 2">
          <img src="../img/m/settings.png" alt="" class="settingsIcon">
          <span>管理</span>
        </li>
        <li @click="editFun()">
          <img src="../img/m/edit.png" alt="" class="editIcon">
          <span>编辑</span>
        </li>
        <li @click="deleteFun()">
          <img src="../img/m/delete.png" alt="" class="deleteIcon">
          <span>删除</span>
        </li>
        <li @click="submitReview()">
          <img src="../img/m/join.png" alt="" class="joinIcon">
          <span>参赛</span>
        </li>
      </ul>
      <div class="cancel_setting" @click="showSetting = false">
        取消
      </div>
    </van-popup>
    <common-footer></common-footer>
  </div>
</template>

<script>
import commonHeader from './common/commonHeader'
import commonFooter from './common/commonFooter'
import { Notify } from 'vant'
import {mapGetters, mapActions} from 'vuex'

export default {
  components: {
    commonHeader,
    commonFooter
  },
  data () {
    return {
      resource: 1,
      resourceMap: {
        1: 'video',
        2: 'photo'
      },
      showSetting: false,
      dataList: [],
      currentWork: null
    }
  },
  computed: {
    ...mapGetters(['getUserInfo'])
  },
  created () {
    this.checkInfo()
    this.getList()
  },
  methods: {
    checkInfo () {
      if (this.getUserInfo.volunteer_info == 0) {
        this.$router.push({
          path: '/mpage/m_userinfo'
        })
      }
    },
    changeResource (item) {
      this.resource = item
      this.dataList = []
      this.getList()
    },
    showSettingsFun (v) {
      this.showSetting = true
      this.currentWork = v
    },
    addWork () {
      Notify({ type: 'warning', message: '作品征集已截止' })
      return
      this.$router.push({
        path: this.resource == 1 ? '/mpage/m_uploadvideowork' : '/mpage/m_workInfo'
      })
    },
    getList () {
      this.$utils.get('/works/myWorks', {type: this.resource}).then(res => {
        if(res.code == 1000) {
          this.dataList = res.data[this.resourceMap[this.resource]]
        } else {
          Notify({ type: 'warning', message: res.msg })
        }
      })
    },
    // 删除
    deleteFun () {
      Notify({ type: 'warning', message: '作品征集已截止' })
      return
      this.$dialog.confirm({
        message: '确定删除该作品吗？',
      })
      .then(() => {
        this.$utils.postForm('/works/delWorks', {works_id: this.currentWork.works_id}).then(res => {
          if(res.code == 1000) {
            Notify({ type: 'success', message: '删除成功!' })
            this.showSetting = false
            this.getList()
          } else {
            Notify({ type: 'warning', message: res.msg })
          }
        })
      })
      .catch(() => {
        
      })
    },
    // 参赛
    submitReview (v) {
      Notify({ type: 'warning', message: '作品征集已截止' })
      return
      this.$dialog.confirm({
        message: '确定参赛该作品吗？',
      })
      .then(() => {
        this.$utils.postForm('/works/submitReview', {works_id: this.currentWork.works_id}).then(res => {
          if(res.code == 1000) {
            this.showSetting = false
            Notify({ type: 'success', message: '作品提交审核成功!' })
            this.getList()
          } else {
            Notify({ type: 'warning', message: res.msg })
          }
        })
      })
      .catch(() => {
        
      })
    },
    // 管理
    manageFun () {
      this.$router.push({
        path: '/mpage/m_uploadpicwork',
        query: {
          works_id: this.currentWork.works_id
        }
      })
    },
    // 编辑
    editFun () {
      Notify({ type: 'warning', message: '作品征集已截止' })
      return
      this.$router.push({
        path: this.resource == 1 ? '/mpage/m_uploadvideowork' : '/mpage/m_workInfo',
        query: {
          works_id: this.currentWork.works_id
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
.home {
  width: 100%;
  margin: 0 auto 0;
  text-align: center;
  font-size: 20px;
  text-align: left;
  .progress {
    width: 13.43rem;
    height: 1.26rem;
    display: block;
    margin: auto;
    margin-top: .6rem;
  }
  .page_content {
    background: #fff;
    box-sizing: border-box;
    width: calc(100% - .9rem);
    margin: auto;
    margin-top: 1.15rem;
    position: relative;
    padding: 1.15rem .37rem .38rem .37rem;
    min-height: 12.3rem;
    .content_nav {
      color: #fff;
      position: absolute;
      left: .75rem;
      top: -.58rem;
      .nav_item {
        width: 5.31rem;
        height: 1.17rem;
        line-height: 1.1rem;
        background-image: linear-gradient(0deg, 
          #aba7e2 0%, 
          #dbd9f6 100%);
        border-radius: .58rem;
        display: inline-block;
        text-align: center;
        &:nth-child(1) {
          margin-right: 1.4rem;
        }
        &.active_item {
          	background-image: linear-gradient(0deg, 
          #746bef 0%, 
          #728bf9 100%);
        }
        .cn_name {
          font-size: .8rem;
          margin-right: .1rem;
          font-weight: bold;
        }
        .en_name {
          font-size: .45rem;
          font-weight: bold;
          opacity: 0.6;
        }
      }
    }
    .works_list {
      li {
        margin-bottom: .4rem;
        display: inline-block;
        .addIcon {
          width: 6.23rem;
          display: block;
        }
        &:nth-child(odd) {
          margin-right: .3rem;
        }
        .cover_con {
          width: 6.23rem;
	        height: 3.9rem;
          position: relative;
          .cover_img {
            width: 100%;
            height: 100%;
            display: block;
          }
          .video_btn {
            position: absolute;
            left: .52rem;
            bottom: .52rem;
            width: .95rem;
            z-index: 2;
          }
          .three_con {
            position: absolute;
            right: .52rem;
            bottom: .5rem;
            z-index: 2;
            img {
              width: .23rem;
              display: block;
            }
            .num {
              color: #fff;
              font-size: .6rem;
              font-weight: bold;
            }
          }
          .finish_flag {
            position: absolute;
            top: 0;
            left: 0;
            width: 2.01rem;
          }
          .join_error {
            background-color: #ff0707;
            padding: .2rem .3rem;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            font-size: .36rem;
            color: #fff;
            line-height: 1.2;
          }
        }
        .work_name {
          font-size: .56rem;
          color: #212121;
          margin-top: .2rem;
          width: 6.23rem;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .author {
          color: #212121;
          font-size: .4rem;
          margin-top: .2rem;
        }
        .country {
          color: #212121;
          font-size: .4rem;
          margin-top: .15rem;
        }
      }
    }
    .more {
      height: 1.21rem;
      line-height: 1.21rem;
      background-color: #9576ef;
      text-align: center;
      color: #fff;
      font-size: .45rem;
      margin-top: .2rem;
    }
  }
  .seting_con {
    li {
      border-bottom: .01rem solid #e6eaf0;
      padding-left: .5rem;
      padding-top: .6rem;
      padding-bottom: .6rem;
      img {
        vertical-align: middle;
      }
      span {
        vertical-align: middle;
        margin-left: .3rem;
        font-size: .6rem;
      }
      &:last-child {
        border-bottom: 0;
        span {
          margin-left: .2rem;
        }
      }
      .settingsIcon {
        width: .83rem;
      }
      .editIcon {
        width: .83rem;
      }
      .deleteIcon {
        width: .72rem;
      }
      .joinIcon {
        width: .82rem;
      }
    }
  }
  .cancel_setting {
    background-color: #b2b3b3;
    font-size: .8rem;
    color: #fff;
    text-align: center;
    line-height: 2.4rem;
  }
}
</style>